document.addEventListener('DOMContentLoaded', function() {
  const container = document.querySelector('.chuala-amplify-builder');
  if (!container) return;
  const swatches = [
    { name: 'Proper - Classic Tonic', color: '#EEB007', caption: 'Classic tonic done right', flavor: 'proper' },
    { name: 'Pomelo - Grapefruit Tonic', color: '#DF5F4D', caption: 'Refreshingly citrus forward', flavor: 'pomelo' },
    { name: 'Modern - Botanical Tonic', color: '#52A886', caption: 'Botanical, bright and complex', flavor: 'modern' },
    { name: 'Zero - Sugar Free Tonic', color: '#000000', caption: 'Zero sugar, zero compromise.', flavor: 'zero' }
  ];

  const CANS_PER_UNIT = 4; // each stepper unit represents this many cans, used only for display

  // Backend note text — fixed and independent of whatever the card displays.
  // These strings must stay byte-identical to what Zoho/ShipStation have always received.
  const TIER_NAMES = {
    2: 'The Curious Mixer \n(8-Cans)',
    4: 'The Serious Host \n(16-Cans)',
    6: 'The Bar Hero \n(24-Cans)'
  };

  let state = { tier: null, price: null, counts: { proper: 0, pomelo: 0, modern: 0, zero: 0 } };
  let isSubmitting = false; // guards against rapid multi-click race condition

  const flavorPanel = document.getElementById('FlavorPanel');
  const flavorBuilderContainer = flavorPanel.querySelector('.mix-builder-container');

  function resetCounts() {
    state.counts = { proper: 0, pomelo: 0, modern: 0, zero: 0 };
  }

  function totalPacks() {
    return Object.values(state.counts).reduce(function(a, b) { return a + b; }, 0);
  }

  function buildFlavorPanel() {
    const maxPacks = state.tier;
    const totalCans = maxPacks * CANS_PER_UNIT;
    flavorBuilderContainer.innerHTML = '';

    let segmentsHtml = '';
    for (let i = 0; i < maxPacks; i++) { segmentsHtml += '<span class="mix-segment"></span>'; }

    const progress = document.createElement('div');
    progress.className = 'mix-progress';
    progress.innerHTML = '<p class="mix-progress-text">Mix and match: <strong class="mix-count">0</strong> of ' + totalCans + ' cans added</p><p class="mix-hint">Select 4-packs of any flavor to fill your case.</p><div class="mix-segments">' + segmentsHtml + '</div>';
    flavorBuilderContainer.appendChild(progress);

    const list = document.createElement('div');
    list.className = 'flavor-stepper-list';
    swatches.forEach(function(s) {
      const shortName = s.name.split(' - ')[0];
      const row = document.createElement('div');
      row.className = 'flavor-stepper-row';
      row.setAttribute('data-flavor', s.flavor);
      row.style.setProperty('--flavor-color', s.color);
      row.innerHTML =
        '<span class="flavor-dot-sm" style="background-color:' + s.color + ';" role="button" tabindex="0" aria-label="Add 4 cans of ' + shortName + '"></span>' +
        '<div class="flavor-info"><strong class="flavor-row-name">' + shortName + '</strong><span class="flavor-row-desc">' + s.caption + '</span></div>' +
        '<div class="stepper"><button type="button" class="stepper-btn minus" aria-label="Remove 4 cans of ' + shortName + '">&minus;</button><span class="stepper-qty">0</span><button type="button" class="stepper-btn plus" aria-label="Add 4 cans of ' + shortName + '">+</button></div>';
      row.querySelector('.minus').onclick = function(e) { e.stopPropagation(); changeCount(s.flavor, -1); };
      row.querySelector('.plus').onclick = function(e) { e.stopPropagation(); changeCount(s.flavor, 1); };
      const dot = row.querySelector('.flavor-dot-sm');
      dot.onclick = function(e) { e.stopPropagation(); changeCount(s.flavor, 1); };
      dot.onkeydown = function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); changeCount(s.flavor, 1); }
      };
      list.appendChild(row);
    });
    flavorBuilderContainer.appendChild(list);

    flavorPanel.style.display = 'block';
    updateUI();
    if (typeof flavorPanel.scrollIntoView === 'function') {
      flavorPanel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  function changeCount(flavor, delta) {
    const max = state.tier;
    if (delta > 0 && totalPacks() >= max) { return; }
    if (delta < 0 && state.counts[flavor] <= 0) { return; }
    state.counts[flavor] += delta;
    updateUI();
    bumpQty(flavor);
  }

  function bumpQty(flavor) {
    const row = flavorPanel.querySelector('.flavor-stepper-row[data-flavor="' + flavor + '"]');
    if (!row) return;
    const qtyEl = row.querySelector('.stepper-qty');
    qtyEl.classList.remove('bump');
    void qtyEl.offsetWidth;
    qtyEl.classList.add('bump');
  }

  function updateUI() {
    const submitBtn = document.getElementById('AmplifySubmit');

    if (isSubmitting) return; // don't let a stray render clobber the "Adding..." state mid-flight

    if (!state.tier) {
      submitBtn.disabled = true;
      submitBtn.innerText = 'Choose case size';
      return;
    }

    const max = state.tier;
    const total = totalPacks();

    flavorPanel.querySelectorAll('.flavor-stepper-row').forEach(function(row) {
      const f = row.getAttribute('data-flavor');
      const qty = state.counts[f];
      row.querySelector('.stepper-qty').innerText = qty * CANS_PER_UNIT;
      row.querySelector('.minus').disabled = qty <= 0;
      row.querySelector('.plus').disabled = total >= max;
      row.classList.toggle('has-qty', qty > 0);
    });

    const countEl = flavorPanel.querySelector('.mix-count');
    if (countEl) { countEl.innerText = total * CANS_PER_UNIT; }
    const segments = flavorPanel.querySelectorAll('.mix-segment');
    segments.forEach(function(s, i) { s.classList.toggle('filled', i < total); });

    const remainingCans = (max - total) * CANS_PER_UNIT;
    if (total >= max) {
      submitBtn.disabled = false;
      submitBtn.innerText = 'Add to cart | $' + state.price;
    } else {
      submitBtn.disabled = true;
      submitBtn.innerText = 'Choose ' + remainingCans + ' more cans';
    }
  }

  container.querySelectorAll('.size-card').forEach(function(card) {
    card.onclick = function() {
      if (isSubmitting) { return; } // don't allow switching sizes mid-submit
      if (card.classList.contains('active')) { return; }
      container.querySelectorAll('.size-card.active').forEach(function(c) { c.classList.remove('active'); });
      card.classList.add('active');
      state.tier = parseInt(card.dataset.tier);
      state.price = card.dataset.price;
      resetCounts(); // reset flavor picks whenever the size changes
      buildFlavorPanel();
    };
  });

  document.getElementById('AmplifySubmit').onclick = function() {
    // hard guard — ignore any click that arrives while a submission is already in flight.
    // This is the fix for the race condition where rapid/double clicks fired multiple concurrent
    // add-to-cart chains, each trying to open the drawer independently, stepping on each
    // other even though item(s) were successfully added to the cart.
    if (isSubmitting) { return; }

    const activeCard = container.querySelector('.size-card.active');
    if (!activeCard) { return; }
    if (totalPacks() !== state.tier) { return; }

    const submitBtn = this;
    // Sourced from TIER_NAMES, not the visible card text — so display copy
    // (e.g. dropping "The") can change freely without touching the backend note.
    const tierName = TIER_NAMES[state.tier];

    const counts = {};
    swatches.forEach(function(s) { if (state.counts[s.flavor] > 0) { counts[s.name] = state.counts[s.flavor]; } });

    const flavorLines = Object.entries(counts).map(function(e) { return e[1] + 'x ' + e[0]; }).join('\n');
    const flavorLinesZoho = Object.entries(counts).map(function(e) { return e[1] + 'x ' + e[0]; }).join(' | ');

    const mixValue = 'Case Size:\n' + tierName + '\n\n' + 'Your Mix:\n' + flavorLines;
    const mixNote = 'Case Size: ' + tierName + ' Your Mix: ' + flavorLinesZoho;

    const variantId = container.dataset[state.tier === 2 ? '8Id' : state.tier === 4 ? '16Id' : '24Id'];

    // lock immediately, before the first await/fetch — this is the critical part.
    // Locking has to happen synchronously in the click handler itself, not inside a .then(),
    // otherwise a second click can still sneak in during the gap before the first fetch resolves.
    isSubmitting = true;
    submitBtn.disabled = true;
    const originalLabel = submitBtn.innerText;
    submitBtn.innerText = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1,
          properties: { '_Mix': mixValue }
        }]
      })
    }).then(function(res) {
      if (!res.ok) { throw new Error('cart/add.js failed with status ' + res.status); }
      if (typeof fbq === 'function') {
        fbq('track', 'AddToCart', {
          content_ids: [variantId],
          content_type: 'product',
          value: parseFloat(state.price),
          currency: 'USD'
        });
      }
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: mixNote })
      });
    }).then(function(res) {
      if (!res.ok) { throw new Error('cart/update.js failed with status ' + res.status); }
      document.dispatchEvent(new CustomEvent('cart:build'));
      // 'cart:open' is not a real Impulse event — it has never done anything.
      // Impulse opens the drawer by listening for clicks on its own header cart
      // icon (class js-drawer-open-cart). Clicking that element triggers the
      // theme's real, already-working open logic on both desktop and mobile.
      var cartDrawerTrigger = document.querySelector('.js-drawer-open-cart');
      if (cartDrawerTrigger) { cartDrawerTrigger.click(); }
    }).catch(function(err) {
      console.error('Chuala bundle builder: add to cart failed', err);
    }).finally(function() {
      isSubmitting = false;
      submitBtn.disabled = false;
      submitBtn.innerText = originalLabel;
    });
  };

  updateUI();
});
